import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=0d5e351d&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=0d5e351d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e351d",
  null
  
)

export default component.exports